"use strict";
export const migration0 = (state) => {
  return state;
};
